import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

// React.lazy itself constrains T as ComponentType<any> (props are
// contravariant; ComponentType<unknown> would reject any concrete prop type).
// Mirror that contract here.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type LazyWithPreload<T extends ComponentType<any>> = LazyExoticComponent<T> & {
  preload: () => Promise<unknown>;
};

// Wraps React.lazy so the underlying dynamic-import can be triggered ahead of
// time (e.g. on pointer-enter for nav links). Calling .preload() multiple times
// is safe — the browser dedupes the module fetch and React's lazy() caches the
// resolved module internally.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithPreload<T extends ComponentType<any>>(
  load: () => Promise<{ default: T }>,
): LazyWithPreload<T> {
  const Component = lazy(load) as LazyWithPreload<T>;
  Component.preload = load;
  return Component;
}
